import React from 'react';
import { CustomCarousel } from '../CustomCarousel';

export const CardCarouselBlock = ({ cards }) => {
    return (
        <CustomCarousel>
            {cards.map((card, index) => (
                <a
                    className="cardcarouselblock__article"
                    key={index}
                    href={card.Url}
                >
                    <h3>{card.Title}</h3>
                    <div
                        className="cardcarouselblock__editor-content"
                        dangerouslySetInnerHTML={{
                            __html: card.Description,
                        }}
                    ></div>
                    {card.ReadMoreText && (
                        <div className="cardcarouselblock__link">
                            <p>{card.ReadMoreText}</p>
                            <i className="cardcarouselblock__icon"></i>
                        </div>
                    )}
                </a>
            ))}
        </CustomCarousel>
    );
};
